import { CandidateByCandidateProfile } from 'modules/candidate-profile-analysis/types/CandidateByCandidateProfile';
import { ItemSeparatorItem } from 'common/ui/ItemSeparator';
import { formatDateFromNow } from 'utils/datetime';
import { CandidateStatusChip } from 'modules/analyse/components/CandidateStatusChip';
import { CandidateProfileAnalysisChangeStatus } from 'modules/candidate-profile-analysis/components/CandidateProfileAnalysisChangeStatus';
import { CandidateStatus } from 'generated-graphql/types';
import { CandidateProfileAnalysisUnlock } from 'modules/candidate-profile-analysis/components/CandidateProfileAnalysisUnlock';

export const getCandidateProfileApplicantSeparatorItems = (
  candidate: CandidateByCandidateProfile | null
): ItemSeparatorItem[] => {
  if (!candidate) {
    return [];
  }

  const items: ItemSeparatorItem[] = [];

  const candidateBatch = candidate.candidateBatch;
  const jobDescription = candidateBatch?.jobDescriptionParsed;

  if (jobDescription?.employerName) {
    items.push(jobDescription.employerName);
  }

  if (candidateBatch?.atsJobId) {
    items.push(`Job ID ${candidateBatch.atsJobId}`);
  }

  if (candidateBatch?.createdAt) {
    items.push(`Applied ${formatDateFromNow(candidateBatch.createdAt)}`);
  }

  if (candidate.status) {
    items.push(<CandidateStatusChip status={candidate.status} />);
  }

  if (candidate.isLocked) {
    items.push(<CandidateProfileAnalysisUnlock candidateId={candidate.id} />);
  }

  if (
    !candidate.isLocked &&
    candidate.id &&
    candidate.status &&
    candidateBatch
  ) {
    items.push(
      <CandidateProfileAnalysisChangeStatus
        candidateId={candidate.id}
        atsJobId={candidateBatch.atsJobId}
        defaultIsLocked={candidate.isLocked || false}
        defaultStatus={candidate.status as CandidateStatus}
      />
    );
  }

  return items;
};
